module.exports = __webpack_public_path__ + "img/icon10.935a61a5.png";